import { Maybe } from 'graphql/jsutils/Maybe';

export const capitaliseWhenCSSDoesntWork = (string: Maybe<string>) => {
  if (!string) return '';

  return `${string[0].toUpperCase()}${string?.slice(1)?.toLowerCase()}`;
};
